import { cn } from "@/lib/tailwind";
import { ReactNode, useEffect, useRef, useState } from "react";


const Collapse = ({
  isOpen,
  children,
  classname,
}: {
  isOpen: boolean;
  children: ReactNode;
  classname?: string;
}) => {

  // hooks
  const collapseRef = useRef<HTMLDivElement | null>(null)

  // states
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (!collapseRef.current) return

    const parentDiv = collapseRef.current
    const children = parentDiv.children

    if (children.length <= 0) return;

    setHeight(children[0].scrollHeight)
  }, [isOpen])
  return (
    <div
      ref={collapseRef}
      className={cn(
        `overflow-hidden transition-[height] duration-500 ease-in-out`,
        classname,
      )}
      style={{
        height: isOpen ? height : 0
      }}
    >
      {children}
    </div>
  );
};

export default Collapse;
